import { render } from "./social.vue?vue&type=template&id=63657824&scoped=true"
import script from "./social.vue?vue&type=script&lang=js"
export * from "./social.vue?vue&type=script&lang=js"

import "./social.vue?vue&type=style&index=0&id=63657824&scoped=true&lang=scss"

import exportComponent from "/builds/septacodeprojects/septacode.com/frontend/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63657824"]])

export default __exports__